import React from 'react';
import styles from './ApproveExpired.module.css';
import AuthImage from '../components/AuthImage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ApproveExpired = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/sign_in');
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        <AuthImage />
      </div>

      <div className={styles.content}>
        <div className={styles.title}>
          {t('approve.expired')}
        </div>

        <div className={styles.button} onClick={handleClick}>
          {t('approve.linkRegister')}
        </div>
      </div>
    </div>
  )
}

export default ApproveExpired;
